import React from 'react'
import "./servicesComponents.css"
import Img2 from "../../assets/images/services/eagle-logo.png"
import Img4 from "../../assets/images/services/eagle-uae-color.png"
import Img1 from "../../assets/images/services/eagle-up-wings.png"
import Img7 from "../../assets/images/services/environment-protection-department.png"
import Img6 from "../../assets/images/services/municipility.png"
import Img5 from "../../assets/images/services/public-service-department.png"
import Img8 from "../../assets/images/services/tas-heel.png"
import Img3 from "../../assets/images/services/team-rocket.png"

const ServicesComponents = ({ isRtl }) => {
    return (
        <>
            <section className="serviceComponent">
                <div className="container-fluid g-0">
                    <div className="row g-0 w-100 align-items-stretch">
                        <div className="col-lg-6 col-md-6 col-12 g-0">
                            <div className="serviceBox dark" >
                                <div data-aos-easing="ease-in-out" data-aos="fade-right">
                                    <img src={Img1} alt="" />
                                    <p className="">
                                        {isRtl ? "تلبية جميع احتياجات للمنشآت والموظفين في وزارة الموارد البشرية والتوطين" : "Meeting all the needs of establishments and employees at the Ministry of Human Resources and Emiratisation."}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 g-0">
                            <div className="serviceBox light">
                                <div data-aos-easing="ease-in-out" data-aos="fade-left">
                                    <img src={Img2} alt="" />
                                    <p className="">
                                        {isRtl ? "تخليص جميع المعاملات الخاصة بللمنشآت والموظفين لدى وزارة الداخلية لدولة الامارات العربية المتحدة" : "Processing all transactions related to establishments and employees at the Ministry of Interior of the United Arab Emirates."}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-0 w-100 align-items-stretch">
                        <div className="col-lg-6 col-md-6 col-12 g-0 order-lg-1 order-md-1 order-2">
                            <div className="serviceBox light" >
                                <div data-aos-easing="ease-in-out" data-aos="fade-right">
                                    <img src={Img3} alt="" />
                                    <p className="">
                                        {isRtl ? "انجاز كافة الاوراق الرسمية للمنشأت والموظفين ومتابعتها لدى الهيئة الإتحادية للهوية والجنسية والجمارك وأمن المنافذ" : "Completing all official documents for establishments and employees and following them up with the Federal Authority for Identity, Citizenship, Customs, and Port Security."}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 g-0 order-lg-2 order-md-2 order-1">
                            <div className="serviceBox dark">
                                <div data-aos-easing="ease-in-out" data-aos="fade-left">
                                    <img src={Img4} alt="" />
                                    <p className="">
                                        {isRtl ? "متابعة وانجاز الاوراق الرسمية للمنشأت لدى دائرة التنمية الاقتصادية" : "Following up and completing official documents for establishments with the Department of Economic Development."}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-0 w-100 align-items-stretch">
                        <div className="col-lg-6 col-md-6 col-12 g-0">
                            <div className="serviceBox dark" >
                                <div data-aos-easing="ease-in-out" data-aos="fade-right">
                                    <img src={Img5} alt="" />
                                    <p className="">
                                        {isRtl ? "انجاز متطلبات للمنشآت والموظفين لدى البلدية" : "Fulfilling the requirements of establishments and employees with the Municipality."}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 g-0">
                            <div className="serviceBox light">
                                <div data-aos-easing="ease-in-out" data-aos="fade-left">
                                    <img src={Img6} alt="" />
                                    <p className="">
                                        {isRtl ? "كل ما تتطلبه للمنشآت لدائرة الخدمات العامة" : "Everything establishments require for the Public Services Department."}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-0 w-100 align-items-stretch">
                        <div className="col-lg-6 col-md-6 col-12 g-0 order-lg-1 order-md-1 order-2">
                            <div className="serviceBox light" >
                                <div data-aos-easing="ease-in-out" data-aos="fade-right">
                                    <img src={Img7} alt="" />
                                    <p className="">
                                        {isRtl ? "جميع الخدمات المطلوبة للمنشأت فيهيئة حماية البيئة والتنمية" : "All services required for establishments at the Environmental Protection and Development Authority."}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 g-0 order-lg-2 order-md-2 order-1">
                            <div className="serviceBox dark">
                                <div data-aos-easing="ease-in-out" data-aos="fade-left">
                                    <img src={Img8} alt="" />
                                    <p className="">
                                        {isRtl ? "جميع الخدمات المطلوبة للمنشأت فيهيئة حماية البيئة والتنمية" : "All services required for establishments at the Environmental Protection and Development Authority."}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ServicesComponents